var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{class:_vm.getChipColor(_vm.status)},[_vm._v(_vm._s(_vm.statusLabel[_vm.status]))])}
var staticRenderFns = []

export { render, staticRenderFns }